import { observer } from "mobx-react";
import * as React from "react";
import { Button, Classes, Dialog } from "@blueprintjs/core";

interface Props {
  texto_info: string
  open: boolean
  onClose: () => void;
}

@observer
export class InfoModal extends React.Component<Props, {}> {

  constructor(props) {
    super(props);
  }

  render() {

    return (

      <Dialog isOpen={this.props.open} onClose={() => this.props.onClose()} className="dados-soli">

        <div className={Classes.DIALOG_BODY}>

          <div style={{ fontSize: 12, textAlign: "justify" }}>

            <div dangerouslySetInnerHTML={{ __html: this.props.texto_info }} />

          </div>

        </div>

        <div className={Classes.DIALOG_FOOTER}>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>

            <Button text="Fechar" intent="primary" onClick={() => this.props.onClose()} />

          </div>

        </div>

      </Dialog>

    );

  }

}

export default InfoModal;
